export default {
  deleteTitle: 'Contract',
  overviewTitle: 'Contracts',
  overviewRouterUrl: 'contracts',
  getFilterName (context) { return 'contracts' },
  overviewApiUrl: '/contracts/',
  detailTitle: 'Contract Detail',
  detailRouterUrl: 'contract',
  detailApiUrl: '/contracts/',
  quickFilterName: 'Contract Nr',
  quickFilterField: 'number',
  advancedSearch: true,
  updateNewRecord (context, rec) {
    rec.active = true
    rec.bankinfo_required = true
    rec.check_universityfee_payment = true
    rec.instalments = false
    // rec.registration_fee_required = false
  },
  getDefaultFilter (context) { return {} },
  sortOrder: [
    {
      field: 'last_name',
      sortField: 'last_name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Application Number', name: 'application_number', sortField: 'application_number', link: '#/contract/{id}'},
    {title: 'Student Name', name: 'student_name', sortField: 'student_name', link: '#/student/{student_id}'},
    {title: 'Status', name: 'contract_status_name'},
    {title: 'Code', name: 'scholarship_code'},
    {title: 'Program', name: 'program_shortname'},
    {title: 'Start Date', name: 'start_date', sortField: 'start_date', callback: 'formatDate'},
    {title: 'End Date', name: 'end_date', sortField: 'end_date', callback: 'formatDate'},
    {title: 'Contract Sent', name: 'contract_sent_date', sortField: 'contract_sent_date', callback: 'formatDate'},
    {title: 'Bank Request', name: 'bankinfo_emailrequest_timestamp', sortField: 'bankinfo_emailrequest_timestamp', callback: 'formatDate'},
    {title: 'Bank Updated', name: 'bankinfo_updated_timestamp', sortField: 'bankinfo_updated_timestamp', callback: 'formatDate'},
    {title: 'PF Status Sent', name: 'pf_status_email_timestamp', sortField: 'pf_status_email_timestamp', callback: 'formatDate'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    // {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}
// {
//       "comments": null,
//       "contract_date_sent": null,
//       "contract_status_id": 1,
//       "contract_status_name": "Accepted by ISE",
//       "creation_timestamp": "2017-08-05T18:21:05.007119Z",
//       "creation_user": "Site Admin",
//       "creation_userid": 1,
//       "edit_timestamp": "2017-08-05T18:21:05.007165Z",
//       "edit_user": "Site Admin",
//       "edit_userid": 1,
//       "email_confirmation_sent": null,
//       "end_date": "2019-05-30T00:00:00Z",
//       "id": 1,
//       "application_number": "2017-00-19192",
//       "scholarship_code": "0A",
//       "scholarship_id": 1,
//       "start_date": "2017-05-30T00:00:00Z",
//       "student_id": 1,
//       "student_name": "Asanuma Ai",
//       "y1_program_id": 2,
//       "y1_program_name": "European Master\u2019s in Nuclear Energy",
//       "y1_program_shortname": "EMINE",
//       "y1_university_id": 5,
//       "y1_university_name": "Royal Institute of Technology, Stockholm, Sweden",
//       "y1_university_shortname": "KTH",
//       "y2_program_id": null,
//       "y2_university_id": null
//     },



// WEBPACK FOOTER //
// ./src/views/Contract/FieldDefs.js